import { merge } from 'lodash';
import { evaluateUserFlag, UserMachine } from '~/machines/user-creation';
import { ContextSendMatch } from '~/machines/utils/types';
import { DeepPartial } from '~/typings/utils';
import { CreateAccount, CreateAccountProps } from './create-account.component';

export type CreateAccountContainerProps = {
  micro: ContextSendMatch<UserMachine>;
  overrideCopy?: CreateAccountProps['overrideCopy'];
  overrideProps?: DeepPartial<CreateAccountProps>;
};

export const CreateAccountContainer = ({
  micro: { context, matches, send },
  overrideCopy,
  overrideProps,
}: CreateAccountContainerProps) => {
  const props: CreateAccountProps = {
    context: {
      agentName: context.agentName,
      businessName: context.businessName,
      email: context.email,
      firstName: context.firstName,
      googleUserError: context.googleUserError,
      inviteCode: context.inviteCode,
      lastName: context.lastName,
      phone: context.phone,
      optInToSMS: context.optInToSMS,
      promoCode: context.promoCode,
      utility: context.utility,
      zipCode: context.zipCode,
      funnelId: context.funnelId,
      forceWaitlist: context.forceWaitlist,
      budgetBilling: context.budgetBilling,
    },
    error: context.errors.user,
    flags: {
      disableEmail: evaluateUserFlag(context, 'disableEmail'),
      hideGoogleButton: evaluateUserFlag(context, 'hideGoogleButton'),
      showStripeIdInputs: evaluateUserFlag(context, 'showStripeIdInputs'),
      isInviteCodeRequired: evaluateUserFlag(context, 'isInviteCodeRequired'),
      requireBusinessName: evaluateUserFlag(context, 'requireBusinessName'),
      requirePhone: evaluateUserFlag(context, 'requirePhone'),
      hidePassword: evaluateUserFlag(context, 'hidePassword'),
      hideTerms: evaluateUserFlag(context, 'hideTerms'),
      showPhone: evaluateUserFlag(context, 'showPhone'),
      showInviteCode: evaluateUserFlag(context, 'showInviteCode'),
      showBillingCheckbox: evaluateUserFlag(context, 'showBillingCheckbox'),
    },
    goTo: {
      utility: () => send({ type: 'CHANGE_UTILITY' }),
    },
    next: data => send({ type: 'SUBMIT_USER', data }),
    overrideCopy,
    pending: matches('user.submitting'),
  };

  return <CreateAccount {...merge(props, overrideProps)} />;
};
